import { MAP_TOOLS, Drawing } from "../../../context/RulerContext";

// Selecionar uma marcação que não seja de área (ex: régua de distância) não deve
// alterar a seleção de município — apenas MEASURE_AREA ou a deseleção (drawingId
// nulo) substituem a análise de município exibida no painel/relatório.
export function shouldClearCitySelection(
  drawingId: string | null,
  drawing: Drawing | undefined
): boolean {
  if (!drawingId) return true;
  return drawing?.type === MAP_TOOLS.MEASURE_AREA;
}
